import { BaseParam } from "./BaseParams";

export class GetMagazineParams extends BaseParam {
    constructor(state) {
        super(state)
        if (state == null)
            state = {};

        const { id = null, description = null, name = null } = state;

        this.id = id;
        this.name = name;
        this.description = description;

    }
}


// WEBPACK FOOTER //
// ./src/APIModels/getMagazineParams.js